import React from 'react';

import { useTranslation } from '~/app';
import HorseIcon from '~/components/HorseIcon';

export interface HorseCellProps {
  name: string;
  color: number;
  jockeyName: string;
}

const HorseCell = ({ value }: { value: HorseCellProps }) => {
  const { t } = useTranslation();
  const { name, color, jockeyName } = value;

  return (
    <div className="flex flex-row items-center space-x-4">
      <HorseIcon color={color} className="h-8 w-8" />

      <div className="flex flex-col">
        {jockeyName && (
          <span className="text-xs font-light text-gray-600">
            {t('horseWithJockeyLabel', { placeholders: { jockeyName } })}
          </span>
        )}
        <span>{name}</span>
      </div>
    </div>
  );
};

export default HorseCell;
